<template>
  <div
    id="fee_detail"
    v-loading.fullscreen.lock="pageLoading"
  >
    <div class="main">
      <div class="title_bar">
        <div class="left">
          <div
            v-if="pageState=='show'"
            class="title"
          >
            繳費單
          </div>
          <div
            v-if="pageState=='edit'"
            class="title"
          >
            編輯繳費單
          </div>
          <div
            v-if="pageState=='add'"
            class="title"
          >
            新增繳費單
          </div>
        </div>
        <div
          v-if="pageState=='show'"
          class="right"
        >
          <el-button
            v-if="writeoffReceipt.length < 1"
            round
            @click="pageState='edit'"
          >
            編輯
          </el-button>
          <el-button
            v-else-if="writeoffReceipt.length > 0 && canEditWriteoff"
            round
            @click="pageState = 'addition'"
          >
            編輯
          </el-button>
          <el-button
            v-if="billData.BillStatus=='未啟用'"
            icon="icon-trashcan"
            type="danger"
            round
            @click="handleDelete()"
          >
            刪除
          </el-button>
        </div>
      </div>
      <div class="blockWrap">
        <div class="block_left">
          <div class="title">
            繳費資訊
          </div>
        </div>
        <div class="block_right">
          <el-form
            ref="feeDetailEdit"
            class="list"
            :model="billData"
            status-icon
            :rules="pageState=='edit' || pageState=='add'?editRule:{}"
            label-position="left"
            @submit.native.prevent
          >
            <el-form-item
              label="戶別代碼"
              :prop="pageState == 'add' ? 'household' : ''"
            >
              <el-button
                v-if="pageState == 'add'"
                round
                @click="householdSwitch = true"
              >
                {{ billData.household.TabletNote || $t('Household.SelectHousehold') }}
              </el-button>
              <template v-else>
                {{ billData.TabletNote }}
              </template>
            </el-form-item>
            <el-form-item
              label="繳費期別"
              prop="periodId"
            >
              <el-select
                v-if="pageState == 'add' || editBasicDataMode"
                v-model="billData.periodId"
                placeholder="請選擇"
                size="small"
              >
                <el-option
                  v-for="item in periodData"
                  :key="item.BillBulkId"
                  :label="item.Name"
                  :value="item.BillBulkId"
                  :disabled="item.BillBulkStatus=='未啟用' && (billData.BillStatus == '開啟' || billData.BillStatus == '關閉')"
                >
                  <!-- 不允許由開啟或關閉的期別轉到未啟用的期別 -->
                </el-option>
              </el-select>
              <template v-else>
                {{ periodName }}
              </template>
            </el-form-item>
            <el-form-item
              label="所有權人"
              prop="BillOwner"
            >
              <el-input
                v-if="pageState == 'add' || editBasicDataMode"
                v-model="billData.BillOwner"
                size="small"
                maxlength="20"
                placeholder="限20字"
              />
              <template v-else>
                {{ billData.BillOwner }}
              </template>
            </el-form-item>
            <el-form-item
              label="通訊地址"
              prop="BillOwnerAddress"
            >
              <el-input
                v-if="pageState == 'add' || editBasicDataMode"
                v-model="billData.BillOwnerAddress"
                size="small"
                maxlength="45"
                placeholder="限45字"
              />
              <template v-else>
                {{ billData.BillOwnerAddress }}
              </template>
            </el-form-item>
            <el-form-item
              label="繳費起訖日"
              prop="BillDueDate"
            >
              <el-date-picker
                v-if="pageState == 'add' || editBasicDataMode"
                v-model="billData.BillDueDate"
                value-format="yyyy/MM/dd"
                format="yyyy/MM/dd"
                type="daterange"
                size="small"
                unlink-panels
                range-separator="至"
                start-placeholder="開始"
                end-placeholder="結束"
                :picker-options="dueDatePickerOptions"
              />
              <template v-else>
                {{ (billData.BillDueDate[0]||'') + ' 至 ' + (billData.BillDueDate[1]||'') }}
              </template>
            </el-form-item>
            <el-form-item
              v-if="isCodeRuleExist"
              label="條碼到期日"
              prop="BillBarcodeDate"
            >
              <el-date-picker
                v-if="pageState == 'add' || editBasicDataMode"
                v-model="billData.BillBarcodeDate"
                value-format="yyyy/MM/dd"
                format="yyyy/MM/dd"
                size="small"
                type="date"
                placeholder="選擇日期"
                :picker-options="dueDatePickerOptions"
              />
              <template v-else>
                {{ billData.BillBarcodeDate }}
              </template>
            </el-form-item>
            <el-form-item label="戶別通訊欄">
              <template v-if="pageState == 'add' || editBasicDataMode">
                <el-input
                  v-model="billData.BillCommunicationBar"
                  type="textarea"
                  maxlength="50"
                  :autosize="{ minRows: 2}"
                  placeholder="限50字，期別通訊欄＋戶別通訊欄最多顯示12行"
                  resize="none"
                />
                <span class="num">{{ billData.BillCommunicationBar.length || 0 }}/50</span>
              </template>
              <template v-else>
                {{ billData.BillCommunicationBar }}
              </template>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="blockWrap billTerm">
        <div class="block_left">
          <div class="title">
            繳費項目
          </div>
        </div>
        <div class="block_right">
          <div
            v-if="pageState != 'add'"
            class="items"
          >
            <div class="left">
              啟用狀態
            </div>
            <div class="right">
              <el-tag
                v-if="billData.BillStatus=='未啟用'"
                type="danger"
              >
                未啟用
              </el-tag>
              <el-tag
                v-else-if="billData.BillStatus=='開啟'"
                type="success"
              >
                啟用中
              </el-tag>
              <el-tag
                v-else-if="billData.BillStatus=='關閉'"
                type="info"
              >
                關閉
              </el-tag>
            </div>
          </div>
          <div class="items">
            <div class="left">
              <el-table
                :data="billPaymentItem"
                style="width: 100%"
                align="center"
              >
                <el-table-column
                  type="index"
                  width="50"
                  align="center"
                />
                <el-table-column
                  prop="Name"
                  label="項目明細"
                  width="180"
                >
                  <template slot-scope="scope">
                    <el-form @submit.native.prevent>
                      <el-form-item :class="{'is-error':!scope.row.Name}">
                        <el-input
                          v-if="pageState == 'add' || editBasicDataMode"
                          v-model="scope.row.Name"
                          placeholder="限10字"
                          maxlength="10"
                        />
                        <template v-else>
                          {{ scope.row.Name }}
                        </template>
                      </el-form-item>
                    </el-form>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="Amount"
                  label="金額"
                  width="200"
                  align="right"
                >
                  <template slot-scope="scope">
                    <el-form @submit.native.prevent>
                      <el-form-item :class="{'is-error': amountInputIsError(scope.row.Amount)}">
                        <template v-if="pageState == 'add' || editBasicDataMode">
                          <el-input
                            v-model="scope.row.Amount"
                            v-thousandth
                            maxlength="7"
                          />
                          <div
                            v-if="scope.row.Amount === '-'"
                            class="el-form-item__error"
                          >
                            {{ $t('Fee.BillAmountNotNumber'), }}
                          </div>
                          <div
                            v-else-if="thousandthPlaceToNumber(scope.row.Amount) > BILL_AMOUNT_MAX"
                            class="el-form-item__error"
                          >
                            {{ `繳費項目金額不得超過 ${BILL_AMOUNT_MAX.toLocaleString()}` }}
                          </div>
                        </template>
                        <template v-else>
                          {{ scope.row.Amount.toLocaleString() }}
                        </template>
                      </el-form-item>
                    </el-form>
                  </template>
                </el-table-column>
                <el-table-column
                  v-if="pageState == 'add' || editBasicDataMode"
                  label="操作"
                  width="82"
                  align="center"
                >
                  <template slot-scope="scope">
                    <el-button
                      size="mini"
                      type="danger"
                      plain
                      @click="handleTermDelete(scope.$index)"
                    >
                      刪除
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
              <div
                v-if="pageState == 'add' || editBasicDataMode"
                class="addTerm"
              >
                <el-button
                  size="mini"
                  type="primary"
                  plain
                  @click="handleTermAdd()"
                >
                  新增
                </el-button>
              </div>
              <div class="billAmount">
                <span>應繳 </span>
                <span class="amount">
                  ${{ billAmount }}
                </span>
              </div>
            </div>
          </div>
          <div class="items">
            <div class="left caution">
              ※注意事項
            </div>
            <div class="right cautionText">
              <p>1. 聯信中心規定，特約商店不得將信用卡刷卡手續費轉嫁於持卡人</p>
              <p>2. 貴社區住戶經由代收通路繳費，將於撥付管理費帳款時扣除代收手續費，依據社區銀行帳戶不同，代收手續費收取方案如下：</p>
              <p class="contentText">
                ※若社區委員會戶頭為永豐，ATM/臨櫃免費，超商、信用卡繳費將依規定收取代收手續費
              </p>
              <p class="sec-contentText">
                A.信用卡繳費之代收手續費為單筆10元，將於撥款時扣除
              </p>
              <p class="sec-contentText">
                B.超商繳費之代收手續費依應繳金額級距收取10~15元，將於撥款時扣除
              </p>
              <p class="contentText">
                ※若社區委員會戶頭為非永豐，ATM、超商、信用卡繳費將依規定收取代收手續費
              </p>
              <p class="sec-contentText">
                A.ATM繳費之代收手續費為單筆10元，將於撥款時扣除
              </p>
              <p class="sec-contentText">
                B.信用卡繳費之代收手續費為單筆10元，將於撥款時扣除
              </p>
              <p class="sec-contentText">
                C.超商繳費之代收手續費依應繳金額級距收取10~15元，將於撥款時扣除
              </p>
              <p>應繳金額大於四萬不開放超商繳費，不同費用級距收取之超商代收手續費如下：</p>
              <p class="contentText">
                ※20,000元(含)以下，收取代收手續費10元
              </p>
              <p class="contentText">
                ※20,001元至40.000(含)，收取代收手續費15元
              </p>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="['show', 'addition'].includes(pageState)"
        class="blockWrap payDetail"
      >
        <div class="block_left">
          <div class="title">
            <div>付款明細</div>
            <div class="tip">
              住戶繳費狀況
            </div>
          </div>
        </div>
        <div class="block_right">
          <div class="items">
            <div class="left">
              <el-table
                :data="writeoffReceipt"
                style="width: 100%"
              >
                <el-table-column
                  v-if="pageState == 'addition'"
                  key="writeoffReceipt1"
                  label=""
                  width="120"
                  align="left"
                >
                  <template slot-scope="scope">
                    <el-select
                      v-if="canEditWriteoff"
                      v-model="scope.row.BillId"
                      placeholder="請選擇"
                      size="small"
                    >
                      <el-option
                        v-for="(item, idx) in tabletBillList"
                        :key="`writeoff_bill_${item.BillId}_${idx}`"
                        :label="item.BillBulkName"
                        :value="item.BillId"
                        :disabled="item.BillStatus !== '開啟'"
                      />
                    </el-select>
                    <template v-else>
                      {{ billData.BillBulkName }}
                    </template>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="Amount"
                  label="繳款金額"
                  width="90"
                  align="right"
                >
                  <template slot-scope="scope">
                    {{ scope.row.Amount.toLocaleString() }}
                  </template>
                </el-table-column>
                <el-table-column
                  prop="HandlingFeeDisplay"
                  label="手續費"
                  width="80"
                  align="right"
                />
                <el-table-column
                  prop="Way"
                  label="方式"
                  width="100"
                />
                <el-table-column
                  prop="PayDate"
                  label="繳費日期"
                  width="100"
                />
                <el-table-column
                  prop="EntryDate"
                  label="入帳日期"
                  width="100"
                />
                <el-table-column
                  prop="Sn"
                  label="銷帳編號"
                  width="130"
                />
                <el-table-column
                  class-name="payNote"
                  prop="Note"
                  label="備註"
                  width="130"
                >
                  <template slot-scope="scope">
                    <p @click="noteDialog=true;noteDetail=scope.row.Note;">
                      {{ scope.row.Note }}
                    </p>
                  </template>
                </el-table-column>
                <el-table-column
                  v-if="pageState == 'show'"
                  label="操作"
                  width="90"
                >
                  <template slot-scope="scope">
                    <el-button
                      v-if="scope.row.ConfigPayWayId == 'CashManual'"
                      size="mini"
                      type="danger"
                      plain
                      @click="deleteWriteoffManual(scope.row.ReceiptId)"
                    >
                      刪除
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </div>
      <div class="bottomControl">
        <div v-if="pageState=='show'">
          <el-button
            round
            @click="handleBack()"
          >
            返回繳費單列表
          </el-button>
        </div>
        <div v-else>
          <el-button
            v-if="pageState=='add'"
            round
            @click="handleBack()"
          >
            取消
          </el-button>
          <el-button
            v-if="['edit', 'addition'].includes(pageState)"
            round
            @click="handleCancelEdit('feeDetailEdit')"
          >
            取消
          </el-button>
          <el-button
            type="primary"
            round
            @click="handleSaveEdit('feeDetailEdit')"
          >
            確定
          </el-button>
        </div>
      </div>
    </div>
    <el-dialog
      :title="`繳費備註`"
      :visible.sync="noteDialog"
      custom-class="sm-size"
      :close-on-click-modal="false"
      center
      :show-close="false"
      :lock-scroll="true"
    >
      <p>{{ noteDetail }}</p>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          type="primary"
          round
          @click="noteDialog=false"
        >確定</el-button>
      </span>
    </el-dialog>
    <hosuehold-frame
      :open.sync="householdSwitch"
      @select-household="selectedHousehold"
    />
  </div>
</template>
<script>
import householdFrame from '@/components/HouseholdFrame'
import { checkPaymentDate, checkBarcodeDate, BILL_AMOUNT_MAX, BILL_AMOUNT_MIN } from '@/js/utils/fee'
export default {
  components: {
    'hosuehold-frame': householdFrame
  },
  data () {
    const validateBarcodeDue = (rule, value, callback) => {
      const endDate = this.billData.BillDueDate ? this.billData.BillDueDate[1] : 0
      callback(checkBarcodeDate(value, endDate))
    }
    const validateRangeDate = (rule, value, callback) => {
      if (value && value[0] && value[1]) {
        callback(checkPaymentDate(value[0], value[1]))
      } else {
        callback()
      }
    }
    return {
      isCodeRuleExist: false, // 是否與銀行串接
      pageLoading: false,
      noteDialog: false,
      noteDetail: null,
      // eslint-disable-next-line eqeqeq
      pageState: this.$route.params.billid == 0 ? 'add' : 'show', // show：檢視繳費單 edit：編輯繳費單 add：新增繳費單
      householdSwitch: false,
      periodData: [],
      writeoffReceipt: [],
      billData: {
        TabletId: '',
        periodId: '',
        BillOwner: '',
        BillOwnerAddress: '',
        BillDueDate: [],
        BillBarcodeDate: '',
        BillCommunicationBar: '',
        household: ''
      },
      billPaymentItem: [],
      billDataOri: {},
      billPaymentItemOri: [],
      tabletBillList: [],
      editRule: {
        household: [
          { required: true, message: '請選擇戶別', trigger: 'change' }
        ],
        periodId: [
          { required: true, message: '請選擇期別', trigger: 'change' }
        ],
        BillOwner: [
          { required: true, message: '請輸入所有權人', trigger: 'change' }
        ],
        BillOwnerAddress: [
          { required: true, message: '請輸入通訊地址', trigger: 'change' }
        ],
        BillDueDate: [
          { required: true, message: '請選擇繳費起訖日', trigger: 'change' },
          { validator: validateRangeDate, trigger: 'change' }
        ],
        BillBarcodeDate: [
          { required: true, message: '請選擇條碼到期日', trigger: 'change' },
          { validator: validateBarcodeDue, trigger: 'change' }
        ]
      },
      dueDatePickerOptions: {
        disabledDate: this.getDisabledDate
      },
      BILL_AMOUNT_MAX,
      BILL_AMOUNT_MIN,
      feeType: 'management'
    }
  },
  computed: {
    periodName () {
      // eslint-disable-next-line eqeqeq
      return this.periodData.map(val => val.BillBulkId == this.billData.periodId ? val.Name : '').filter(val => val)[0]
    },
    editBasicDataMode () {
      return this.writeoffReceipt.length < 1 && ['edit'].includes(this.pageState)
    },
    canEditWriteoff () {
      return this.tabletBillList?.filter(v => v.BillId !== +this.$route.params.billid).length > 0
    },
    billAmount () {
      const amountNumber = this.billPaymentItem.filter(val => val.Amount).reduce((a, b) => a + this.thousandthPlaceToNumber(b.Amount) || 0, 0)
      return amountNumber.toLocaleString()
    }
  },
  watch: {
    'billData.BillDueDate' (val) {
      console.log(val)
      if (val && val[1] && !this.isCodeRuleExist) {
        console.log(val[1])
        this.billData.BillBarcodeDate = val[1]
      }
    },
    isCodeRuleExist (val) {
      if (val) {
        this.billData.BillBarcodeDate = this.billDataOri.BillBarcodeDate
      }
    }
  },
  mounted () {
    this.pageLoading = true
    this.getData()
    this.getPaymentItem()
    this.getWriteoffReceipt()
    this.getBillBulkBasicList()
    if (this.$store.state.fee.configData) {
      this.isCodeRuleExist = this.$store.state.fee.configData.ConfigCommunityCodeRuleIsExisting
    } else {
      this.getConfigData()
    }
    this.feeType = this.$route.params.type
  },
  methods: {
    getData () { // 取得繳費單資料
      // eslint-disable-next-line eqeqeq
      if (this.pageState != 'add') {
        const queryPath = {
          billBulkId: this.$route.params.bulkid,
          billId: this.$route.params.billid
        }
        apiBillservice.BillBulk.GetBill(
          queryPath
        ).then((res) => {
          res.data.Data.BillStartDate = this.$formatDate(res.data.Data.BillStartDate)
          res.data.Data.BillDueDate = this.$formatDate(res.data.Data.BillDueDate)
          res.data.Data.BillSettleDate = this.$formatDate(res.data.Data.BillSettleDate)
          res.data.Data.BillBarcodeDate = this.$formatDate(res.data.Data.BillBarcodeDate)
          this.billData = Object.assign({}, res.data.Data, { periodId: parseInt(this.$route.params.bulkid), BillDueDate: [res.data.Data.BillStartDate, res.data.Data.BillDueDate] })
          this.billDataOri = _cloneDeep(this.billData)
          console.log(res.data.Data)
          this.pageLoading = false
        }).catch((err) => {
          this.$message({
            message: '取得繳費單資料失敗，請稍後再試',
            type: 'warning'
          })
          console.log(err.response)
          this.pageLoading = false
          this.handleBack()
        })
      } else {
        this.billData.periodId = parseInt(this.$route.params.bulkid)
        this.pageLoading = false
      }
    },
    getConfigData () { // 取得社區基本設定
      apiBillservice.Config.GetCommunitySettingForm(
      ).then((res) => {
        this.isCodeRuleExist = res.data.Data.ConfigCommunityCodeRuleIsExisting
      }).catch((err) => {
        console.log(err.response)
        this.$message({
          message: '取得社區基本設定失敗，請稍後再試',
          type: 'warning'
        })
      })
    },
    getBillBulkBasicList () { // 取得期別列表
      apiBillservice.BillBulk.GetBillBulkBasicList(
      ).then((res) => {
        this.periodData = res.data.Data.filter((e) => {
          // eslint-disable-next-line eqeqeq
          if (e.BillBulkStatus != '刪除') {
            return e
          }
        })
      }).catch((err) => {
        this.$message({
          message: '取得期別選單失敗，請稍後再試',
          type: 'warning'
        })
        console.log(err.response)
      })
    },
    getPaymentItem () { // 取得繳費項目
      // eslint-disable-next-line eqeqeq
      if (this.pageState != 'add') {
        const queryPath = {
          billBulkId: this.$route.params.bulkid,
          billId: this.$route.params.billid
        }
        apiBillservice.BillBulk.GetBillTerm(
          queryPath
        ).then((res) => {
          this.billPaymentItem = res.data.Data
          this.billPaymentItemOri = _cloneDeep(this.billPaymentItem)
          console.log(res.data.Data)
        }).catch((err) => {
          this.$message({
            message: '取得繳費項目失敗，請稍後再試',
            type: 'warning'
          })
          console.log(err.response)
        })
      }
    },
    getWriteoffReceipt () { // 取得付款明細
      // eslint-disable-next-line eqeqeq
      if (this.pageState == 'show') {
        const queryPath = {
          billBulkId: this.$route.params.bulkid,
          billId: this.$route.params.billid
        }
        apiBillservice.BillBulk.GetBillReceipt(
          queryPath
        ).then((res) => {
          console.log(res.data.Data)
          res.data.Data.PayDate = this.$formatDate(res.data.Data.PayDate)
          this.writeoffReceipt = res.data.Data.map(val => {
            val.HandlingFeeDisplay = `${val.ConfigHandlingFeeModeShowName} ${val.HandlingFee}`
            val.PayDate = this.$formatDate(val.PayDate)
            val.EntryDate = this.$formatDate(val.EntryDate)
            return val
          })
          if (this.writeoffReceipt.length > 0) {
            let retryTime = 0
            const triggerGetTabletBillList = () => {
              if (this.billData && this.billData.TabletId) {
                this.getTabletBillList()
              } else {
                const maxRetryTime = 5
                if (retryTime > maxRetryTime) {
                  this.$message({
                    message: '取得帳單失敗，請稍後再試',
                    type: 'warning'
                  })
                  console.log('getTabletBillList() 嘗試超過最大重試次數')
                } else {
                  setTimeout(() => { triggerGetTabletBillList() }, 500)
                }
                retryTime++
              }
            }

            triggerGetTabletBillList()
          }
        }).catch((err) => {
          this.$message({
            message: '取得付款明細失敗，請稍後再試',
            type: 'warning'
          })
          console.log(err)
        })
      }
    },
    getTabletBillList () { // 取得戶別繳費單列表
      const queryPath = {
        tabletId: this.billData.TabletId
      }
      const billId = this.$route.params.billid
      apiBillservice.BillBulk.GetTabletBillList(
        queryPath
      ).then((res) => {
        console.log(res.data.Data)
        this.tabletBillList = res.data.Data.filter(e => {
          return (e.BillStatus === '開啟' && (+new Date() > +new Date(e.BillStartDate))) || e.BillId === Number(billId)
        })
      }).catch((err) => {
        this.$message({
          message: '取得戶別繳費單列表失敗，請稍後再試',
          type: 'warning'
        })
        console.log(err.response)
      })
    },
    handleDelete () { // 刪除繳費單
      this.$confirm('此操作將永久刪除該繳費單, 是否繼續?', '提示', {
        confirmButtonText: '確定',
        cancelButtonText: '取消',
        roundButton: true,
        type: 'warning',
        closeOnClickModal: false
      }).then(() => {
        this.pageLoading = true
        const queryPath = {
          billBulkId: this.$route.params.bulkid,
          billId: this.$route.params.billid
        }
        apiBillservice.BillBulk.DeleteBill(
          queryPath
        ).then((res) => {
          this.pageLoading = false
          this.$message({
            type: 'success',
            message: '刪除成功!'
          })
          this.handleBack()
        }).catch(() => {
          this.pageLoading = false
          this.$message({
            type: 'info',
            message: '刪除失敗，請稍後再試。'
          })
        })
      }).catch(e => {})
    },
    handleBack () { // 返回繳費單列表
      this.$router.push({ name: 'FeePaymentList', params: { id: this.$route.params.bulkid, type: this.feeType } })
    },
    handleBackToShow () { // 新增or編輯繳費單完成 -> 檢視繳費單
      // eslint-disable-next-line eqeqeq
      if (this.pageState == 'add') { // 目前新增成功回列表
        this.handleBack()
      } else {
        this.getData()
        this.getPaymentItem()
        this.getWriteoffReceipt()
      }
      this.pageLoading = false
      this.pageState = 'show'
    },
    handleCancelEdit (formName) { // 取消編輯繳費單 -> 檢視繳費單
      this.billData = _cloneDeep(this.billDataOri)
      this.billPaymentItem = _cloneDeep(this.billPaymentItemOri)
      this.$refs[formName].resetFields()
      this.pageState = 'show'
    },
    handleTermDelete (ind) { // 繳費項目 - 刪除
      console.log(ind)
      this.billPaymentItem.splice(ind, 1)
    },
    handleTermAdd (item) { // 繳費項目 - 新增
      if (this.billPaymentItem.length < 10) { // 項目限制十筆
        this.billPaymentItem.push({ Name: null, Amount: null })
      } else {
        this.$message({
          type: 'warning',
          message: '繳費項目至多十筆'
        })
      }
    },
    selectedHousehold (content) { // 選擇戶別完成
      console.log(content)
      this.billData.household = content
      this.householdSwitch = false
    },
    handleSaveEdit (formName) { // 儲存新增or編輯繳費單
      this.$refs[formName].validate((valid) => {
        if (valid) { // 繳費資訊驗證
          if (this.billPaymentItem.every(val => val.Name)) { // 繳費項目驗證
            if (this.billPaymentItem.some(val => this.thousandthPlaceToNumber(val.Amount) > this.BILL_AMOUNT_MAX)) { // 繳費金額驗證
              this.$message({
                showClose: true,
                message: this.$t('Fee.ExceedBillAmount', { maxAmount: this.BILL_AMOUNT_MAX.toLocaleString() }),
                type: 'warning'
              })
              return false
            } else if (this.billPaymentItem.some(val => val.Amount === '-')) { // 只輸入負號
              return false
            }
            console.log('saved')
            // eslint-disable-next-line eqeqeq
            if (this.pageState == 'add') { // 新增繳費單
              console.log('新增繳費單')
              this.saveAddBillData()
                .then(this.handleBackToShow)
                .catch(() => {
                  this.pageLoading = false
                })
            // eslint-disable-next-line eqeqeq
            } else if (this.pageState == 'edit') { // 編輯繳費單
              console.log('編輯繳費單')
              this.saveChangePeriod()
                .then(this.savePayinfo)
                .then(this.savePayTemrs)
                .then(this.handleBackToShow)
                .catch(() => {
                  this.pageLoading = false
                })
            // eslint-disable-next-line eqeqeq
            } else if (this.pageState == 'addition') { // 移轉款項
              console.log('移轉款項')
              this.saveMoveWriteoff()
                .then(this.handleBackToShow)
                .then(this.getWriteoffReceipt)
                .catch(() => {
                  this.pageLoading = false
                })
            }
          } else {
            this.$message({
              showClose: true,
              message: '繳費項目 - 仍有未填的項目明細',
              type: 'warning'
            })
            return false
          }
        } else {
          this.$message({
            showClose: true,
            message: '繳費資訊 - 請確認所有必填欄位已填妥',
            type: 'warning'
          })
          return false
        }
      })
    },
    saveChangePeriod () { // 儲存編輯繳費單 - 更改期別
      return new Promise((resolve, reject) => {
        this.pageLoading = true
        console.log('saveChangePeriod')
        // eslint-disable-next-line eqeqeq
        if (!_isEmpty(this.billDataOri) && this.billDataOri.periodId != this.billData.periodId) {
          console.log('saveChangePeriod api')
          const queryPath = {
            billBulkId: this.$route.params.bulkid,
            billId: this.$route.params.billid,
            anotherBillBulkId: this.billData.periodId
          }
          apiBillservice.BillBulk.PutBillBulkId(
            queryPath
          ).then((res) => {
            console.log(res)
            this.billDataOri.periodId = this.billData.periodId
            this.$router.replace({ params: { bulkid: this.billData.periodId } })
            resolve()
          }).catch(err => {
            // eslint-disable-next-line eqeqeq
            if (err.response.data.ErrorMessage.Code == 400002) {
              this.$message({
                showClose: true,
                message: err.response.data.ErrorMessage.Description,
                type: 'warning'
              })
            } else {
              this.$message({
                showClose: true,
                message: '更改期別失敗，請稍後再試',
                type: 'warning'
              })
            }

            reject(err.response)
          })
        } else {
          resolve()
        }
      })
    },
    savePayinfo () { // 儲存編輯繳費單 - 繳費資訊
      return new Promise((resolve, reject) => {
        console.log('savePayinfo')
        console.log(this.billData)
        if (!_isEqual(this.billDataOri, this.billData)) {
          console.log('savePayinfo api')
          const queryPath = {
            billBulkId: this.billData.periodId,
            billId: this.$route.params.billid
          }
          const requestData = {
            Owner: this.billData.BillOwner,
            Address: this.billData.BillOwnerAddress,
            DiscernCode: 'string',
            BillType: 'Undefined',
            CommunicationBar: this.billData.BillCommunicationBar,
            StartDate: this.billData.BillDueDate[0],
            DueDate: this.billData.BillDueDate[1],
            BarcodeDate: this.billData.BillBarcodeDate
          }
          apiBillservice.BillBulk.PutBill(
            queryPath,
            requestData
          ).then((res) => {
            console.log(res)
            resolve()
          }).catch(err => {
            this.$message({
              showClose: true,
              message: '編輯繳費資訊失敗，請稍後再試',
              type: 'warning'
            })
            reject(err.response)
          })
        } else {
          resolve()
        }
      })
    },
    savePayTemrs () { // 儲存編輯繳費單 - 繳費項目
      return new Promise((resolve, reject) => {
        console.log('savePayTemrs', this.billPaymentItem)
        // if(item.Name){ //必須輸入項目名稱
        //   this.billPaymentItem.push({'Name':item.Name,'Amount':parseInt(Number(item.Amount))||0})
        // }else{
        //   this.$message({
        //     type: 'warning',
        //     message: '請輸入項目名稱'
        //   });
        // }
        if (!_isEqual(this.billPaymentItemOri, this.billPaymentItem)) {
          const queryPath = {
            billBulkId: this.billData.periodId,
            billId: this.$route.params.billid
          }
          const requestData = _cloneDeep(this.billPaymentItem).map((val, ind) => {
            val.Amount = this.thousandthPlaceToNumber(val.Amount)
            return val
          })
          apiBillservice.BillBulk.PutBillTerm(
            queryPath,
            requestData
          ).then((res) => {
            console.log(res)
            resolve()
          }).catch(err => {
            this.$message({
              showClose: true,
              message: '編輯繳費項目失敗，請稍後再試',
              type: 'warning'
            })
            reject(err.response)
          })
        } else {
          resolve()
        }
      })
    },
    saveAddBillData () { // 儲存新增繳費單
      return new Promise((resolve, reject) => {
        this.pageLoading = true
        const requestData = [{
          BillTabletOwner: {
            TabletId: this.billData.household.TabletId,
            Owner: this.billData.BillOwner,
            Address: this.billData.BillOwnerAddress,
            DiscernCode: 'string'
          },
          BillType: 'Undefined',
          CommunicationBar: this.billData.BillCommunicationBar,
          StartDate: this.billData.BillDueDate[0],
          DueDate: this.billData.BillDueDate[1],
          BarcodeDate: this.billData.BillBarcodeDate,
          BillTerms: _cloneDeep(this.billPaymentItem).map((val, ind) => {
            val.Amount = this.thousandthPlaceToNumber(val.Amount)
            return val
          })
        }]
        const queryPath = {
          billBulkId: this.billData.periodId
        }
        apiBillservice.BillBulk.PostBill(
          queryPath,
          requestData
        ).then((res) => {
          console.log(res)
          this.pageLoading = false
          this.$message({
            showClose: true,
            message: '新增繳費單成功！',
            type: 'success'
          })
          resolve(res.data.Data)
        }).catch(err => {
          this.pageLoading = false
          console.log(err.response)
          // eslint-disable-next-line eqeqeq
          if (err.response.data.ErrorMessage.Code == 400002) {
            this.$message({
              showClose: true,
              message: '新增失敗，此期別已有該戶別的繳費單！',
              type: 'warning'
            })
            reject(new Error(`saveAddBillData fail:${err.response}`))
          } else if (err.response.data.ErrorMessage.Code === 400005) {
            this.$alert(this.$t('Fee.CreateFeeFail400005'), '', {
              confirmButtonText: this.$t('General.OK'),
              type: 'warning',
              callback: action => {
                // 不執行
              }
            })
            reject(new Error(`saveAddBillData fail:${err.response}`))
          } else {
            this.$message({
              showClose: true,
              message: '新增失敗，請稍後再試！',
              type: 'warning'
            })
            reject(new Error(`saveAddBillData fail:${err.response}`))
          }
        })
      })
    },
    async saveMoveWriteoff () { // 移轉帳單
      return new Promise(async (resolve, reject) => {
        const oriPeriodId = this.$route.params.billid
        const receiptModifyArr = this.writeoffReceipt.filter((receiptV) => {
          return !_isEqual(oriPeriodId, receiptV.BillId)
        })
        if (receiptModifyArr.length === 0) { return resolve() }
        try {
          await this.moveWriteoff(receiptModifyArr)
          this.$message({
            type: 'success',
            message: '儲存成功'
          })
          resolve()
        } catch (e) {
          console.log(e)
          this.$message({
            message: '移動款項失敗，請稍後再試',
            type: 'warning'
          })
          reject(new Error('移動款項失敗'))
        }
      })
    },
    deleteWriteoffManual (receiptId) { // 刪除手動入帳
      this.$confirm('確認是否刪除手動入帳紀錄？若刪除後資料將無法復原。', '提示', {
        confirmButtonText: '確定',
        cancelButtonText: '取消',
        roundButton: true,
        type: 'warning',
        closeOnClickModal: false
      }).then(() => {
        this.pageLoading = true
        const queryPath = {
          billBulkId: this.$route.params.bulkid,
          billId: this.$route.params.billid,
          receiptId
        }
        apiBillservice.BillBulk.DeleteWriteoffManual(
          queryPath
        ).then((res) => {
          console.log(res.data)
          this.getWriteoffReceipt()
          this.pageLoading = false
        }).catch((err) => {
          this.$message({
            message: '刪除失敗，請稍後再試',
            type: 'warning'
          })
          console.log(err.response)
          this.getWriteoffReceipt()
          this.pageLoading = false
        })
      }).catch(() => {
        this.pageLoading = false
      })
    },
    moveWriteoff (receiptModifyArr) { // 移動收據
      return new Promise((resolve, reject) => {
        const requestData = []
        receiptModifyArr.forEach((item) => {
          requestData.push(
            {
              WriteoffId: item.WriteoffId,
              BillId: item.BillId
            }
          )
        })
        apiBillservice.Writeoff.PutWriteoff(
          requestData
        ).then((res) => {
          console.log(res.data)
          resolve(res.data)
        }).catch((err) => {
          reject(err)
        })
      })
    },
    getDisabledDate (e) {
      return dayjs(e).isAfter(dayjs().add(365, 'day'), 'date')
    },
    thousandthPlaceToNumber (value) {
      if (typeof value !== 'string') return value
      if (value === '-') return 0
      return Number(value ? value.replace(',', '') : '0')
    },
    amountInputIsError (amount) {
      let numberAmount = 0
      if (typeof amount === 'string') {
        if (isNaN(Number(amount.replace(',', '')))) return true
        numberAmount = this.thousandthPlaceToNumber(amount)
      }
      if (numberAmount > BILL_AMOUNT_MAX || numberAmount < BILL_AMOUNT_MIN) return true
      return false
    }
  }
}
</script>
<style lang="sass" scoped>
#fee_detail
  padding: 50px 0
  ::v-deep .el-dialog
    +basicDialog
    p
      line-height: 25px
  .main
    min-width: 1140px
    max-width: 1140px
    margin: 0 auto
    padding: 30px
    color: $mainFontColor
    background-color: #fff
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.1)
    border-radius: $pageBorderRadius
    box-sizing: border-box
    .title_bar
      display: flex
      justify-content: space-between
      align-items: center
      margin: 0 0 30px 0
      padding-bottom: 20px
      .title
        font-weight: bold
        font-size: map-get($fontSize,xx-large)
        color: $mainFontColor
        text-align: left
      .tip
        font-size: map-get($fontSize,small)
        color: $subFontColor
  ::v-deep .el-form.list
    display: inline-flex
    flex-wrap: wrap
    width: 100%
    .el-form-item
      display: flex
      align-items: flex-start
      width: 100%
      box-sizing: border-box
      +basicForm
      &.half
        width: 50%
      &__label
        font-weight: bold
        flex-basis: 105px
        vertical-align: top
      &__content
        flex: 1
        max-width: 400px
        .el-select,.el-date-editor
          width: 100%
  .blockWrap
    text-align: left
    display: inline-flex
    flex-wrap: wrap
    width: 100%
    margin-bottom: 30px
    padding-left: 100px
    box-sizing: border-box
    &:not(:nth-last-child(-n+2))
      border-bottom: dashed 1px $borderDark1
    .block_left
      width: 15%
    .block_right
      +basicForm
      width: 85%
    .title
      font-size: map-get($fontSize,large)
      font-weight: bold
      color: $mainFontColor
      line-height: 30px
      .tip
        font-size: map-get($fontSize,small)
        font-weight: normal
        color: $subFontColor
    .items
      display: flex
      align-items: center
      width: 100%
      margin: 0px 0 25px
      box-sizing: border-box
      .left
        font-size: map-get($fontSize,small)
        margin-right: 20px
        &.caution
          align-self: flex-start
      .right
        flex: 1
        &.cautionText p
          line-height: 1.4
          &.contentText
            text-indent: 0.5em
          &.sec-contentText
            text-indent: 1.5em
    &.billTerm
      ::v-deep .el-form-item
        margin: 0
        &__content
          position: unset
          font-size: map-get($fontSize,small)
          .el-form-item__error
            top: unset
            bottom: 0
            left: 10px
      .addTerm
        padding: 15px 9px
        text-align: right
        border-bottom: solid 1px #ebeef5
      .billAmount
        padding: 15px
        text-align: right
        color: $subFontColor
        font-weight: bold
        .amount
          font-size: map-get($fontSize,large)
          color: $warnColor
    &.payDetail
      ::v-deep td.payNote p
        color: $mainColor
        text-decoration: underline
        cursor: pointer
        overflow: hidden
        text-overflow: ellipsis
        display: -webkit-box
        -webkit-line-clamp: 2
        -webkit-box-orient: vertical
  .bottomControl
    text-align: center
    border-top: solid 1px $borderDark1
    padding: 30px 0 0
  ::v-deep .el-table
    +basicTable
</style>
